import Stomp, { Client } from 'webstomp-client';
import SockJS from 'sockjs-client';
import store from 'cache/store';
import { cacheStompXD } from 'features/socketSlice';

interface XOCDIA {
    stompClient: Client | null;
    connect: () => void;
    disconnect: () => void;
    sendMessage: (topic: string, payload: any) => void;
}

const xdSocket: XOCDIA = {
    stompClient: null,

    connect: () => {
        const urlXD = process.env.REACT_APP_URL_XD;
        const { tokenXD } = store.getState().auth;
        const url = `${urlXD}/gamemini/ws/xocdia?access_token=${tokenXD}`;
        const socket = new SockJS(url);
        const stompClient = Stomp.over(socket);
        xdSocket.stompClient = stompClient;
        stompClient.debug = () => {};
        const header = {};
        stompClient.connect(header, () => {
            store.dispatch(cacheStompXD(stompClient));
        });
    },
    disconnect: () => {
        if (xdSocket.stompClient) {
            xdSocket.stompClient.disconnect();
        }
    },
    sendMessage: (topic: string, payload: any) => {
        if (xdSocket.stompClient && xdSocket.stompClient.connected) {
            const { apiToken } = store.getState().auth;
            const header = {
                Authorization: apiToken || '',
            };
            xdSocket.stompClient.send(
                topic, // destination
                JSON.stringify(payload), // body
                header // header
            );
        }
    },
};
export default xdSocket;
